/**
 * Lean YAML-frontmatter parsing (no YAML dependency) shared by skills + commands.
 * Handles single-line values AND block scalars (`>`, `>-`, `|`, `|-`, …) — CC skills
 * often fold long descriptions across indented lines, which a single-line regex truncates.
 */

/** Extract the `---`-delimited frontmatter block + the body that follows it. */
export function splitFrontmatter(md: string): { block: string; body: string } {
  const m = md.match(/^---\s*\n([\s\S]*?)\n---\s*\n?/);
  return { block: m ? m[1] : '', body: (m ? md.slice(m[0].length) : md).trim() };
}

/** Grab a scalar field from a frontmatter block by key (case-insensitive). Folds block scalars to one line. */
export function grabField(block: string, key: string): string | undefined {
  const lines = block.split('\n');
  const i = lines.findIndex((l) => new RegExp(`^${key}\\s*:`, 'i').test(l));
  if (i < 0) return undefined;
  const inline = lines[i].replace(new RegExp(`^${key}\\s*:\\s*`, 'i'), '');
  // Block scalar (`>`/`|` with optional chomping `-`/`+`): gather the following more-indented lines.
  if (/^[>|][+-]?\s*$/.test(inline)) {
    const folded: string[] = [];
    for (let j = i + 1; j < lines.length && /^\s+\S/.test(lines[j]); j++) folded.push(lines[j].trim());
    return folded.join(' ').trim() || undefined; // fold to one line (catalog descriptions are single-line)
  }
  return inline.trim().replace(/^["']|["']$/g, '') || undefined;
}
